/*
 * A donde queria ir quien todavia no habia entrado.
 *
 * Alguien elige "Pro" en la portada, se encuentra la pantalla de acceso y, al
 * terminar, aparece en "Codigos" sin que nadie vuelva a mencionar el plan que
 * queria. Esto recuerda la intencion y la cumple despues.
 *
 * Por que en `localStorage` y no en el estado de React, que seria lo natural:
 * con el enlace magico el usuario SALE del navegador. Abre su correo, pulsa el
 * enlace, y puede acabar en otra pestana o directamente en el movil. Todo lo
 * que viva en memoria se pierde por el camino. Con Google no pasa —la ventana
 * vuelve sola— pero el mismo almacen sirve para los dos y evita tener dos
 * mecanismos que mantener.
 *
 * El destino viaja ademas en la URL de la pantalla de acceso, porque el
 * almacen es por navegador: quien abra el enlace magico en el movil no tiene
 * lo que se guardo en el portatil, y asi al menos el caso de un solo aparato
 * —que es el habitual— funciona.
 */

const CLAVE = 'apuntaqr:destino';

/**
 * Solo rutas de esta misma aplicacion.
 *
 * Sin esta comprobacion, cualquiera podria mandar un enlace a
 * /acceso?destino=https://sitio-que-roba-contrasenas.example y la victima
 * acabaria ahi **despues de entrar**, confiada y con la sesion recien abierta.
 * Es el agujero clasico de las redirecciones abiertas.
 *
 * Tiene que empezar por una sola barra: "//otro-sitio.com" es una URL
 * completa aunque lo parezca, y el navegador la sigue.
 */
function esRutaInterna(ruta: string): boolean {
  return /^\/(?!\/)/.test(ruta) && !ruta.includes('\\');
}

export function guardarDestino(ruta: string | null | undefined): void {
  if (!ruta || !esRutaInterna(ruta)) return;
  try {
    localStorage.setItem(CLAVE, ruta);
  } catch {
    // Sin almacenamiento se pierde la intencion y se aterriza en la portada
    // del panel. Es peor experiencia, no un fallo.
  }
}

/**
 * Recoge el destino y lo borra: se cumple una vez y se olvida.
 *
 * Si no se borrara, el siguiente acceso desde el mismo navegador volveria a
 * llevar a la pantalla de contratar, semanas despues y sin que nadie lo haya
 * pedido.
 */
export function recogerDestino(): string | null {
  try {
    const guardado = localStorage.getItem(CLAVE);
    localStorage.removeItem(CLAVE);
    return guardado && esRutaInterna(guardado) ? guardado : null;
  } catch {
    return null;
  }
}
